import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PaymentForm from 'components/signUp/IN_PROGRESS_PaymentForm';

function mapStateToProps(state, ownProps) {
  return {
    signupReducer: state.signupReducer
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentForm);



// WEBPACK FOOTER //
// ./src/containers/PaymentContainer.js